import React, { Component } from "react";

//need to refactor this
//`URL(${this.props.book.imageLinks.thumbnail})`
class Book extends Component {
  state = {};
  render() {
    let selectedBook = this.props.book;
    let BookAuthor = this.props.book.authors;
    let BookTitle = this.props.book.title;
    let defaultCoverImage =
      "https://books.google.com/googlebooks/images/no_cover_thumb.gif";

    let displayThumbnail = this.props.book.imageLinks
      ? this.props.book.imageLinks.thumbnail
      : defaultCoverImage;
    return (
      <div className="book">
        <div className="book-top">
          <div
            className="book-cover"
            style={{
              width: 128,
              height: 193,
              backgroundImage: `URL(${displayThumbnail})`,
            }}
          />
          <div className="book-shelf-changer">
            {/* move shelf function to updare book and shelf */}
            {/* (event) => this.props.moveShelf(this.props.book, event.target.value)>*/}
            <select
              onChange={(event) =>
                this.props.moveShelf(selectedBook, event.target.value)
              }
              value={this.props.currentShelf}
            >
              <option value="move" disabled>
                Move to...
              </option>
              <option value="currentlyReading">Currently Reading</option>
              <option value="wantToRead">Want to Read</option>
              <option value="read">Read</option>
              <option value="none">None</option>
            </select>
          </div>
        </div>
        <div className="book-title">{BookTitle}</div>
        <div className="book-authors">{BookAuthor}</div>
      </div>
    );
  }
}

export default Book;
